import './ccf-collapse-panel-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfCollapsePanelIconProps extends SvgIconProps  {}
/**
 * component used to display collapse panel icon
 * @param props - CcfCollapsePanelIconProps
 * @example - <CcfCollapsePanelIcon />
 * @returns SVG of collapse panel icon
 */
export function CcfCollapsePanelIcon(props: CcfCollapsePanelIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_Collapse_Panel" clipPath="url(#clip-ic_Collapse_Panel)">
        <g id="Group_119089" data-name="Group 119089" transform="translate(-166 -47)">
          <path id="Path_25292" data-name="Path 25292" d="M19.961,23.765A.719.719,0,0,0,20.722,23V21.939l2.815,2.815L24.6,23.689l-2.967-2.967H23A.761.761,0,0,0,23,19.2H19.961a.719.719,0,0,0-.761.761V23A.719.719,0,0,0,19.961,23.765Z" transform="translate(158.399 39.246)" fill="#526b7a"/>
          <path id="Path_25293" data-name="Path 25293" d="M23,5.32H21.863l2.815-2.815L23.613,1.44,20.722,4.331V3.038a.761.761,0,0,0-1.522,0V6.081a.719.719,0,0,0,.761.761H23a.719.719,0,0,0,.761-.761A.719.719,0,0,0,23,5.32Z" transform="translate(158.399 48.561)" fill="#526b7a"/>
          <path id="Path_25294" data-name="Path 25294" d="M5.913,2.277a.719.719,0,0,0-.761.761v1.37L2.185,1.44,1.12,2.505,3.935,5.32H2.87a.719.719,0,0,0-.761.761.719.719,0,0,0,.761.761H5.913a.719.719,0,0,0,.761-.761V3.038a.719.719,0,0,0-.761-.761Z" transform="translate(167.881 48.561)" fill="#526b7a"/>
          <path id="Path_25295" data-name="Path 25295" d="M6,19.2H2.954a.761.761,0,0,0,0,1.522H4.247L1.28,23.689l1.065,1.065,2.891-2.891V23A.719.719,0,0,0,6,23.765.719.719,0,0,0,6.758,23V19.961A.719.719,0,0,0,6,19.2Z" transform="translate(167.797 39.246)" fill="#526b7a"/>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfCollapsePanelIcon;
